<script lang="ts">
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import * as m from '$paraglide/messages';
	import { onDestroy, onMount } from 'svelte';
	import { getMapContext } from 'svelte-maplibre';

	let timeoutId: ReturnType<typeof setTimeout>;
	let orientationAngle = $state(0);
	let isCompassVisible = $state(false);

	// Add an offset to the rotation because the uno compass icon does not point north by default
	const ROTATION_OFFSET = Math.PI / 4;

	const { map } = $derived(getMapContext());

	function updateCompassOrientationAngle() {
		const angle = map?.transform.bearing;
		orientationAngle = angle || orientationAngle;

		if (angle !== 0) {
			isCompassVisible = true;
			return;
		}

		timeoutId = setTimeout(() => {
			if (map?.transform.bearing === 0) {
				isCompassVisible = false;
			}
		}, 3000);
	}

	function resetMapOrientation() {
		map?.resetNorth();
	}

	onMount(async () => {
		map?.on('rotate', updateCompassOrientationAngle);
	});

	onDestroy(() => {
		map?.off('rotate', updateCompassOrientationAngle);
		clearTimeout(timeoutId);
	});
</script>

<div class={{ hidden: !isCompassVisible }}>
	<Button
		ariaLabel={m.map_controls__aria_labels__compass()}
		variant="filled"
		color="white"
		size="sm"
		onclick={resetMapOrientation}
	>
		<span class="rotation flex" style="--angle: {orientationAngle - ROTATION_OFFSET}rad;">
			<Icon icon="explore" tag="span" />
		</span>
	</Button>
</div>

<style>
	.rotation {
		transform: rotate(var(--angle));
		/* This is to avoid firefox issues with border appearing when rotating */
		transform-style: preserve-3d;
	}
</style>
